import { Dropdown } from '@cmsgov/ds-medicare-gov';
import React from 'react';
import cloneObject from '../functions/clone.object';
import the from '../objects/the';
import './css/hidden.error.message.css';

interface DropDownProps {
    errorMessage: string | null
    inputRef: any
    label: string
    name: string
    onBlur: (event: any) => void
    onChange: (event: any) => void
    options: any
    style?: React.CSSProperties
    value: any
}

export default function DropDown(props: DropDownProps) {
    const getErrorMessage = () => {
        if (!props.errorMessage)
            return null;
        return <>
            <div style={{
                color: the.color.darkRed,
                fontSize: 14,
            }}>{props.errorMessage}</div>
        </>;
    };

    const clonedProps: any = cloneObject(props);
    delete clonedProps.errorMessage;

    return <>
        <Dropdown {...clonedProps}/>
        {getErrorMessage()}
    </>;
}